
import { supabase } from '@/integrations/supabase/client';
import { getLogger } from '@/utils/logger';

const log = getLogger({ module: 'AuthCleanup' });

/**
 * Utility functions to clean up stale auth state and prevent auth issues
 */
export const clearStaleAuthData = () => {
  log.info('Cleaning up potential stale auth data');
  
  // Remove specific keys that might be stale
  const keysToCheck = [
    'supabase.auth.token',
    'supabase-auth-token',
  ];
  
  keysToCheck.forEach(key => {
    try {
      // Clean up stale auth data from localStorage
      if (localStorage.getItem(key)) {
        log.info(`Cleaning up potential stale auth data: ${key}`);
        localStorage.removeItem(key);
      }
    } catch (e) {
      log.error(`Error cleaning up ${key}:`, e);
    }
  });
};

export const refreshAndValidateSession = async () => {
  try {
    log.info('Validating session');
    
    // Use the reliable getSession method to check current session
    const { data, error } = await supabase.auth.getSession();
    
    if (error) {
      log.error('Session validation error:', error);
      return null;
    }
    
    if (!data.session) {
      log.info('No active session during validation');
      return null;
    }
    
    // Check token expiry
    const expiresAt = data.session.expires_at;
    const now = Math.floor(Date.now() / 1000);
    
    // If token is expired or about to expire, refresh it
    if (expiresAt && expiresAt < now + 60) {
      log.info('Session expired or about to expire, refreshing');
      const { data: refreshData, error: refreshError } = await supabase.auth.refreshSession();
      
      if (refreshError) {
        log.error('Session refresh error:', refreshError);
        return null;
      }
      
      return refreshData.session;
    }
    
    return data.session;
  } catch (e) {
    log.error('Unexpected error during session validation:', e);
    return null;
  }
};
